import { Plus } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";

interface ProductListHeaderProps {
  onRegisterClick: () => void;
}

/**
 * Page heading + "Add New Product" action, styled after
 * `IngredientListHeader`
 * (src/screens/lcaIngredients/ingredientList/components/IngredientListHeader.tsx)
 * which itself follows the Recipe Simulator list header.
 */
const ProductListHeader = ({ onRegisterClick }: ProductListHeaderProps) => {
  return (
    <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-gap-4">
      <div>
        <h1 className="tw-font-display tw-text-2xl tw-font-bold tw-text-foreground">Products</h1>
        <p className="tw-mt-1 tw-text-sm tw-text-muted-foreground">
          Registered products, their sales units and calculated climate change impact
        </p>
      </div>
      <Button onClick={onRegisterClick} className="tw-shrink-0 tw-gap-2">
        <Plus className="tw-h-4 tw-w-4" />
        Register New Product
      </Button>
    </div>
  );
};

export default ProductListHeader;
